import { __decorate, __metadata } from "tslib";
import { BaseService, HTTP_METHOD, Method, restParamMapper, Service, STATUS, } from '@cbbt/lib-interface';
import { DocumentNotFoundError } from './errors/DocumentNotFoundError.js';
import { IndividualRecordNotFoundError } from './errors/IndividualRecordNotFoundError.js';
import { ProductFeatureNotFoundError } from './errors/ProductFeatureNotFoundError.js';
import { CreateIndividualAddressesRequest } from './models/addresses/CreateIndividualAddressesRequest.js';
import { IndividualAddressesResponse } from './models/addresses/IndividualAddressesResponse.js';
import { CreateIndividualRequest } from './models/CreateIndividualRequest.js';
import { CreateIndividualResponse } from './models/CreateIndividualResponse.js';
import { DeleteIndividualByIdRequest } from './models/DeleteIndividualByIdRequest.js';
import { CreateDocumentRequest } from './models/documents/CreateDocumentRequest.js';
import { DeleteDocumentRequest } from './models/documents/DeleteDocumentRequest.js';
import { DocumentsResponse } from './models/documents/DocumentsResponse.js';
import { UpdateAdditionalDocumentRequest } from './models/documents/UpdateAdditioanlDocumentsRequest.js';
import { UpdateDocumentRequest } from './models/documents/UpdateDocumentRequest.js';
import { GetIndividualByIdRequest } from './models/GetIndividualByIdRequest.js';
import { GetIndividualByIdResponse } from './models/GetIndividualByIdResponse.js';
import { GetKapIndividualsByIdRequest } from './models/GetKapIndividualsByIdRequest.js';
import { GetKapIndividualsByIdResponse } from './models/GetKapIndividualsByIdResponse.js';
import { IdvSkippedRequest } from './models/identity-verification/IdvSkippedRequest.js';
import { IdvSkippedResponse } from './models/identity-verification/IdvSkippedResponse.js';
import { IdvSubmitRequest } from './models/identity-verification/IdvSubmitRequest.js';
import { IdvSubmitResponse } from './models/identity-verification/IdvSubmitResponse.js';
import { UpdateCaseRefNumber } from './models/identity-verification/UpdateCaseRefNumber.js';
import { UpdateIdentityVerificationDetailRequest } from './models/identity-verification/UpdateIdentityVerificationDetailRequest.js';
import { UpdateIdentityVerificationDetailResponse } from './models/identity-verification/UpdateIdentityVerificationDetailResponse.js';
import { CreateKapIndividualRequest } from './models/kap-individual/CreateKapIndividualRequest.js';
import { CreateKapIndividualResponse } from './models/kap-individual/CreateKapIndividualResponse.js';
import { NationalityAndTaxResidentResponse } from './models/nationality-taxresident/NationalityAndTaxResidentResponse.js';
import { SetNationalityAndTaxResidentRequest } from './models/nationality-taxresident/SetNationalityAndTaxResidentRequest.js';
import { CreateIndividualOtherNamesRequest } from './models/other-names/CreateIndividualOtherNamesRequest.js';
import { IndividualOtherNamesResponse } from './models/other-names/IndividualOtherNamesResponse.js';
import { CreateProductFeatureRequest } from './models/productFeatures/CreateProductFeatureRequest.js';
import { DeleteProductFeatureRequest } from './models/productFeatures/DeleteProductFeatureRequest.js';
import { ProductFeatureResponse } from './models/productFeatures/ProductFeatureResponse.js';
import { SetIndividualPersonalDetailsRequest } from './models/SetIndividualPersonalDetailsRequest.js';
import { SetIndividualPersonalDetailsResponse } from './models/SetIndividualPersonalDetailsResponse.js';
let IndividualService = class IndividualService extends BaseService {
    createIndividual(_transport, request) {
        return this.unimplemented(request);
    }
    getIndividualById(_transport, request) {
        return this.unimplemented(request);
    }
    GetKapIndividualsById(_transport, request) {
        return this.unimplemented(request);
    }
    setIndividualPersonalDetails(_transport, request) {
        return this.unimplemented(request);
    }
    createIndividualOtherNames(_transport, request) {
        return this.unimplemented(request);
    }
    getIndividualOtherNames(_transport, request) {
        return this.unimplemented(request);
    }
    deleteIndividualOtherNames(_transport, request) {
        return this.unimplemented(request);
    }
    createIndividualAddresses(_transport, request) {
        return this.unimplemented(request);
    }
    getIndividualAddresses(_transport, request) {
        return this.unimplemented(request);
    }
    deleteIndividualAddresses(_transport, request) {
        return this.unimplemented(request);
    }
    setNationalityAndTaxResident(_transport, request) {
        return this.unimplemented(request);
    }
    getNationalityAndTaxResident(_transport, request) {
        return this.unimplemented(request);
    }
    deleteNationalityAndTaxResident(_transport, request) {
        return this.unimplemented(request);
    }
    createDocuments(_transport, request) {
        return this.unimplemented(request);
    }
    updateDocuments(_transport, request) {
        return this.unimplemented(request);
    }
    getDocumentsById(_transport, request) {
        return this.unimplemented(request);
    }
    deleteDocuments(_transport, request) {
        return this.unimplemented(request);
    }
    updateIdentityVerificationDetail(_transport, request) {
        return this.unimplemented(request);
    }
    submitIdentityVerificationDetail(_transport, request) {
        return this.unimplemented(request);
    }
    updateIdvSkip(_transport, request) {
        return this.unimplemented(request);
    }
    updateCaseRefNumber(_transport, request) {
        return this.unimplemented(request);
    }
    updateAdditioanlDocuments(_transport, request) {
        return this.unimplemented(request);
    }
    createKapIndividuals(_transport, request) {
        return this.unimplemented(request);
    }
    deleteIndividual(_transport, request) {
        return this.unimplemented(request);
    }
    createProductFeature(_transport, request) {
        return this.unimplemented(request);
    }
    deleteProductFeature(_transport, request) {
        return this.unimplemented(request);
    }
};
__decorate([
    Method({
        summary: 'create individual method',
        description: 'create individual method',
        successStatus: STATUS.CREATED,
        throws: [],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/',
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, CreateIndividualRequest]),
    __metadata("design:returntype", CreateIndividualResponse)
], IndividualService.prototype, "createIndividual", null);
__decorate([
    Method({
        summary: 'get individual method',
        description: 'get individual method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/{individualId}/',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", GetIndividualByIdResponse)
], IndividualService.prototype, "getIndividualById", null);
__decorate([
    Method({
        summary: 'get multiple individual method',
        description: 'get multiple individual method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/',
        params: [restParamMapper.query({ from: 'individualId', to: 'ids' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetKapIndividualsByIdRequest]),
    __metadata("design:returntype", GetKapIndividualsByIdResponse)
], IndividualService.prototype, "GetKapIndividualsById", null);
__decorate([
    Method({
        summary: 'update individual method',
        description: 'update individual method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/personalDetails',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, SetIndividualPersonalDetailsRequest]),
    __metadata("design:returntype", SetIndividualPersonalDetailsResponse)
], IndividualService.prototype, "setIndividualPersonalDetails", null);
__decorate([
    Method({
        summary: 'create individual other names method',
        description: 'create individual other names method',
        successStatus: STATUS.CREATED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/{individualId}/otherNames',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, CreateIndividualOtherNamesRequest]),
    __metadata("design:returntype", IndividualOtherNamesResponse)
], IndividualService.prototype, "createIndividualOtherNames", null);
__decorate([
    Method({
        summary: 'get individual other names method',
        description: 'get individual other names method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/{individualId}/otherNames',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", IndividualOtherNamesResponse)
], IndividualService.prototype, "getIndividualOtherNames", null);
__decorate([
    Method({
        summary: 'delete individual other names method',
        description: 'delete individual other names method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.DELETE,
        path: '/{individualId}/otherNames',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", void 0)
], IndividualService.prototype, "deleteIndividualOtherNames", null);
__decorate([
    Method({
        summary: 'create individual addresses method',
        description: 'create individual addresses method',
        successStatus: STATUS.CREATED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/{individualId}/addresses',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, CreateIndividualAddressesRequest]),
    __metadata("design:returntype", IndividualAddressesResponse)
], IndividualService.prototype, "createIndividualAddresses", null);
__decorate([
    Method({
        summary: 'get individual addresses method',
        description: 'get individual addresses method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/{individualId}/addresses',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", IndividualAddressesResponse)
], IndividualService.prototype, "getIndividualAddresses", null);
__decorate([
    Method({
        summary: 'delete individual addresses method',
        description: 'delete individual addresses method',
        successStatus: STATUS.ACCEPTED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.DELETE,
        path: '/{individualId}/addresses',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", void 0)
], IndividualService.prototype, "deleteIndividualAddresses", null);
__decorate([
    Method({
        summary: 'update individual Nationality and Tax resident',
        description: 'update individual method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/nationalityAndTaxResident',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, SetNationalityAndTaxResidentRequest]),
    __metadata("design:returntype", NationalityAndTaxResidentResponse)
], IndividualService.prototype, "setNationalityAndTaxResident", null);
__decorate([
    Method({
        summary: 'Get individual Nationality and Tax resident',
        description: 'Get individual Nationality and Tax resident method',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/{individualId}/nationalityAndTaxResident',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", NationalityAndTaxResidentResponse)
], IndividualService.prototype, "getNationalityAndTaxResident", null);
__decorate([
    Method({
        summary: 'Delete individual Nationality and Tax resident',
        description: 'Delete individual Nationality and Tax resident method',
        successStatus: STATUS.ACCEPTED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.DELETE,
        path: '/{individualId}/nationalityAndTaxResident',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", void 0)
], IndividualService.prototype, "deleteNationalityAndTaxResident", null);
__decorate([
    Method({
        summary: 'Create Documents',
        description: 'create documents in individual DB',
        successStatus: STATUS.CREATED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/{individualId}/documents',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, CreateDocumentRequest]),
    __metadata("design:returntype", DocumentsResponse)
], IndividualService.prototype, "createDocuments", null);
__decorate([
    Method({
        summary: 'Update Documents',
        description: 'Update documents in individual DB',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/documents',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, UpdateDocumentRequest]),
    __metadata("design:returntype", DocumentsResponse)
], IndividualService.prototype, "updateDocuments", null);
__decorate([
    Method({
        summary: 'Get Documents details',
        description: 'Get All Documents by individual id',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError, DocumentNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.GET,
        path: '/{individualId}/documents',
        params: [restParamMapper.path({ from: 'individualId', to: 'id' })],
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, GetIndividualByIdRequest]),
    __metadata("design:returntype", DocumentsResponse)
], IndividualService.prototype, "getDocumentsById", null);
__decorate([
    Method({
        summary: 'Delete Documents details',
        description: 'Documents by id',
        successStatus: STATUS.ACCEPTED,
        throws: [],
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/documents/delete',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, DeleteDocumentRequest]),
    __metadata("design:returntype", void 0)
], IndividualService.prototype, "deleteDocuments", null);
__decorate([
    Method({
        summary: 'update individual identity verification retry count',
        description: 'update individual identity verification retry count',
        successStatus: STATUS.OK,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/updateRetryCount',
        params: [
            restParamMapper.path({ from: 'individualId', to: 'id' }),
            restParamMapper.query({ from: 'isReset', to: 'isReset' }),
        ],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, UpdateIdentityVerificationDetailRequest]),
    __metadata("design:returntype", UpdateIdentityVerificationDetailResponse)
], IndividualService.prototype, "updateIdentityVerificationDetail", null);
__decorate([
    Method({
        summary: 'submit identity verification details in individual',
        description: 'submit identity verification details in individual',
        successStatus: STATUS.CREATED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/{individualId}/submit',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, IdvSubmitRequest]),
    __metadata("design:returntype", IdvSubmitResponse)
], IndividualService.prototype, "submitIdentityVerificationDetail", null);
__decorate([
    Method({
        summary: 'update skip Idv',
        description: 'update skip Idv',
        successStatus: STATUS.CREATED,
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/{individualId}/updateIdvSkip',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, IdvSkippedRequest]),
    __metadata("design:returntype", IdvSkippedResponse)
], IndividualService.prototype, "updateIdvSkip", null);
__decorate([
    Method({
        summary: 'Update Case Ref Number',
        description: 'Update Case Ref Number',
        successStatus: STATUS.OK,
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/updateCaseRefNumber',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, UpdateCaseRefNumber]),
    __metadata("design:returntype", UpdateCaseRefNumber)
], IndividualService.prototype, "updateCaseRefNumber", null);
__decorate([
    Method({
        summary: 'Update Additional Documents',
        description: 'Update additional documents in individual DB',
        successStatus: STATUS.OK,
        throws: [],
    }),
    Method.rest({
        method: HTTP_METHOD.PUT,
        path: '/{individualId}/additionalDocuments',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, UpdateAdditionalDocumentRequest]),
    __metadata("design:returntype", DocumentsResponse)
], IndividualService.prototype, "updateAdditioanlDocuments", null);
__decorate([
    Method({
        summary: 'create kap individual method',
        description: 'create kap individual method',
        successStatus: STATUS.CREATED,
        throws: [],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/kapIndividuals',
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, CreateKapIndividualRequest]),
    __metadata("design:returntype", CreateKapIndividualResponse)
], IndividualService.prototype, "createKapIndividuals", null);
__decorate([
    Method({
        summary: 'Delete individual details',
        description: 'Delete indivdual details by Ids',
        successStatus: STATUS.ACCEPTED,
        throws: [IndividualRecordNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.DELETE,
        path: '/',
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, DeleteIndividualByIdRequest]),
    __metadata("design:returntype", void 0)
], IndividualService.prototype, "deleteIndividual", null);
__decorate([
    Method({
        summary: 'Create product feature',
        description: 'Create product feature for the individual',
        successStatus: STATUS.CREATED,
        throws: [],
    }),
    Method.rest({
        method: HTTP_METHOD.POST,
        path: '/{individualId}/productFeature',
        params: [restParamMapper.path({ from: 'individualId', to: 'individualId' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, CreateProductFeatureRequest]),
    __metadata("design:returntype", ProductFeatureResponse)
], IndividualService.prototype, "createProductFeature", null);
__decorate([
    Method({
        summary: 'Delete product feature',
        description: 'Delete product feature for the individual',
        successStatus: STATUS.ACCEPTED,
        throws: [ProductFeatureNotFoundError],
    }),
    Method.rest({
        method: HTTP_METHOD.DELETE,
        path: '/productFeature/{productFeatureId}',
        params: [restParamMapper.path({ from: 'productFeatureId', to: 'id' })],
        body: restParamMapper.json(),
    }),
    Method.grpc(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, DeleteProductFeatureRequest]),
    __metadata("design:returntype", void 0)
], IndividualService.prototype, "deleteProductFeature", null);
IndividualService = __decorate([
    Service({
        description: 'This is an individual service for BCB onboarding',
    }),
    Service.rest({
        basePath: '/individual',
    })
], IndividualService);
export { IndividualService };
//# sourceMappingURL=IndividualService.js.map